import { v1ApiClient } from '@/services';

import type { SharedLink, SharedLinkTargetType } from './types';

type CreateSharedLinkParams = {
  workspaceId: string;
  targetId: string;
  targetType: SharedLinkTargetType;
  link: string;
  expire: number;
  password?: string;
};
type CreateSharedLinkResponse = SharedLink;
type CreateSharedLinkFunction = (
  params: CreateSharedLinkParams,
) => Promise<CreateSharedLinkResponse>;

export const createSharedLink: CreateSharedLinkFunction = ({
  workspaceId,
  ...body
}) =>
  v1ApiClient
    .post(`/workspaces/${workspaceId}/shared-link`, {
      target_id: body.targetId,
      target_type: body.targetType,
      link: body.link,
      expire: body.expire,
      password: body.password,
    })
    .then((res) => res.data);
